import type { PriceId } from '@iheartjane/types';
import { PriceIdEnum } from '@iheartjane/types';
import { z } from 'zod';

export const CartProductMinimalSchema = z.object({
  count: z.number(),
  price_id: z.enum(PriceIdEnum),
  product_id: z.number(),
});
export type CartProductMinimal = z.infer<typeof CartProductMinimalSchema>;

type CartItem = {
  count: number;
  price_id: PriceId;
  product_id: number;
};

export const mergeCartItem = (
  newCartItem: CartItem,
  cartItems: CartItem[]
): CartProductMinimal[] => {
  const cartProducts = [...cartItems];

  const existingItem = cartProducts.find((item) => {
    return (
      item.product_id === newCartItem.product_id &&
      item.price_id === newCartItem.price_id
    );
  });

  if (existingItem) {
    existingItem.count = newCartItem.count;
  } else {
    cartProducts.push(newCartItem);
  }

  return cartProducts;
};
